// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1lYGY","container":"styles_container__1x_ol","title":"styles_title__1a7J_","wrapper":"styles_wrapper__1zJVu","answer":"styles_answer__2IYKG"};